import React from 'react';
import bem from 'utils/bem.js';
import Icon from 'components/Icon/index.js';
import './index.sass';

const { cnBlock } = bem('conference-video-button');
export const VideoButton = ({className, name, active, ...rest}) => {
    return (
        <div className={cnBlock(className, { 'active': active })} {...rest}>
            <Icon name={name} />
        </div>
    )
}
